import React, { FC } from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { RootState } from "store/reducers/types";
import { redirectToAuth } from "utils/api";

export type PrivateRouteProps = RouteComponentProps & {
  isAuthenticated: boolean;
};

const PrivateRoute: FC<PrivateRouteProps> = ({ isAuthenticated, history, ...rest }: PrivateRouteProps) => {
  if (!isAuthenticated) {
    redirectToAuth(document.location.pathname);
    return null;
  }

  return <Route history={history} {...rest} />;
};

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.session.isAuthenticated,
});

export default connect(mapStateToProps, null)(PrivateRoute);
